import React, { useState, useEffect } from "react";
import Alert from "react-bootstrap/Alert"
import { Button, Select } from "semantic-ui-react";
import { useStore } from "../../../app/stores/store";
import { Formik, Form, Field, useFormik } from "formik";
import * as Yup from "yup";
import { observer } from "mobx-react-lite";
import CCTiposDeTransaccionStore from "../../../app/stores/CCTiposDeTransaccionStore";
import { CCTipoDeTransaccion } from "../../../app/models/CCTiposDeTransaccion";

interface Props {
    userId: string;
    cuenta: string;
    catEdicionesId: number;
    updateCourseList: () => void;
}

export default observer(function ModalCrearMovimiento(props: Props){
  const { modalStore, CCTMovimientoStore, CCTiposDeTransaccionStore, CuotasStore} = useStore();
  const {CCTipoDeTransaccionByCodigo} = CCTiposDeTransaccionStore;
    
  useEffect(() => {
    CCTiposDeTransaccionStore.loadCCTiposDeTransacciones();
  }, [CCTiposDeTransaccionStore, props.userId]);

  const [mensajeRequerido, setMensajeRequerido] = useState(false);
  
  const validarNumeroDeDocumentoContable = Yup.object ({
    numeroDeDocumentoContable: Yup.number()
      
  })
  
  const documentoRequerido = () => {
    setMensajeRequerido(true);
  };

  const noRequerido = () => {
    setMensajeRequerido(false);
  };

  async function crearMovimiento(codigoTipoTransaccion: number, numeroDeDocumentoContable: number, pagado: boolean){
    const now = new Date();
    const valor = await CuotasStore.getCuota(props.catEdicionesId)
    
    if(typeof valor == "number"){
      let movimiento = {
        idCliente: props.userId,
        cuenta: props.cuenta,
        codigoTipoTransaccion: codigoTipoTransaccion,
        numeroTransaccion: props.cuenta.substring(0,5),
        fecha: now,
        valor: valor,
        estatusMovimiento: "AC",
        usuarioRegistro: "",
        fechaRegistro: now,
        usuarioAnulo: "",
        fechaAnulado: "",
        numeroDeDocumentoContable: numeroDeDocumentoContable,
        pagado: pagado
      };
      
      CCTMovimientoStore.createCCTMovimiento(movimiento).then( () => {
        modalStore.closeModal()
        props.updateCourseList()
      })
    }else{
      modalStore.closeModal()
      alert("Ocurrió un error al leer el monto de la cuota.")
    }
    
  }

  return (
    <div className="modal_pago_cur modal-reset-password">
      <div className="modal_pago_head">
        <h1>Agregar movimiento</h1>
      </div>

      <Formik
        enableReinitialize
        initialValues={{codigoTipoTransaccion : "1",
          numeroDeDocumentoContable: ""
        }}
        onSubmit={(values) => {
          
          //Chequeando si es pago o cargo
          if(values.codigoTipoTransaccion == "2" || values.codigoTipoTransaccion == "3" || values.codigoTipoTransaccion == "4" || values.codigoTipoTransaccion == "8" || values.codigoTipoTransaccion == "10" || values.codigoTipoTransaccion == "13"){
            //chequeando si se ingreso numero de documento
            crearMovimiento(parseInt(values.codigoTipoTransaccion),parseInt(values.numeroDeDocumentoContable),true);
          }else{
            crearMovimiento(parseInt(values.codigoTipoTransaccion), 0,false);
          }
        }}
        validationSchema = {validarNumeroDeDocumentoContable}
      >
        {({ handleSubmit, isValid, isSubmitting, dirty, values, errors, touched}) => (
          <Form
            onSubmit={handleSubmit}
            autoComplete="off"
            className="contenido_modal_pago"
          >
            <p>Escoge los datos para agregar el nuevo movimiento:</p>
            <div style ={{margin:"10px"}}>
                <label htmlFor="codigoTipoTransaccion">Tipo de transacción</label>
                <Field as="select" 
                    id="codigoTipoTransaccion"
                    name="codigoTipoTransaccion">
                      {
                      CCTipoDeTransaccionByCodigo.map((tipoDeTransaccion: CCTipoDeTransaccion) =>{
                        
                        return (
                          <option value={tipoDeTransaccion.codigoTipoTransaccion}>{tipoDeTransaccion.descripcion}</option>
                        )
                      })}
                </Field>
                {(values.codigoTipoTransaccion == "2" || values.codigoTipoTransaccion == "3" || values.codigoTipoTransaccion == "4" || values.codigoTipoTransaccion == "8" || values.codigoTipoTransaccion == "10" || values.codigoTipoTransaccion =="13") && (
                  <div style={{width:"100%"}}>
                    <label htmlFor="numeroDeDocumentoContable" style={{marginTop:"30px", width: "100%"}}>Número de Documento Contable</label>
                    <Field type="number"
                    id="numeroDeDocumentoContable" 
                    name="numeroDeDocumentoContable" 
                    placeholder="Ingresa el número de documento contable..."
                    style={{width:"100%", marginBottom: "5px"}}
                    />
                    {errors.numeroDeDocumentoContable && touched.numeroDeDocumentoContable ? (
                      <Alert variant="danger">{errors.numeroDeDocumentoContable}</Alert>
                    ) : null}
                    {mensajeRequerido && <Alert variant="danger">Número de documento contable requerido</Alert>}
                  </div>
                )}
                
            </div>

            <div className="botones_pago_modal">
                <Button
                loading={CCTMovimientoStore.loading}
                content={"Cancelar"}
                className="gray"
                onClick={modalStore.closeModal}
              />
              <Button
                loading={CCTMovimientoStore.loading}
                type="submit"
                content={"Confirmar"}
                className="blue"
              />
            </div>
          </Form>
        )}
      </Formik>
  </div>
)})